import mgzf from './mgzf'
import mogoroomFind from './mogoroomFind'
import brokerApp from './brokerApp'
import mogoroomRenterBehavior from './mogoroomRenterBehavior'
import authorize from './authorize'
import renterCoupon from './renterCoupon'
import analytics from './analytics'
import assetsMgzfFind from './assetsMgzfFind'
import renterEmbed from './renterEmbed'
import custSeek from './custSeek'
import rcmd from './rcmd'
import loan from './loan'
import renterembedSale from './renterembedSale'
import commbiz from './commbiz'
import roomFindWeb from './roomFindWeb'
import mrktWeb from './mrktWeb'
import renterOperation from './renterOperation'
export default {
  mgzf,
  analytics,
  mogoroomFind,
  brokerApp,
  mogoroomRenterBehavior,
  authorize,
  renterCoupon,
  renterEmbed,
  assetsMgzfFind,
  custSeek,
  rcmd,
  loan,
  renterembedSale,
  commbiz,
  renterOperation,
  roomFindWeb,
  mrktWeb
}



// WEBPACK FOOTER //
// ./src/api/index.js